import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import Form from '../../../components/common/Form/index'
import Top from '../../../components/common/TopBack/index'
function Recruit(props) {

  const innerWidth = useSelector(state => (state.autoAdaptReducer.innerWidth))
  const formBase = {
    formList: [{
      name: 'positionName',
      label: '招聘职位',
      type: 'Input',
      baseInfo: [''],
      render: ''
    }, {
      name: 'recordtime',
      label: '发布时间',
      type: 'DatePicker',
      baseInfo: [''],
      render: ''
    }, {
      name: 'numbers',
      label: '招聘人数',
      type: 'Input',
      baseInfo: [''],
      render: ''
    }, {
      name: 'address',
      label: '工作地点',
      type: 'Input',
      baseInfo: [''],
      render: ''
    }, {
      name: 'department',
      label: '部门',
      type: 'Input',
      baseInfo: [''],
      render: ''
    }]
}
  return (
    <div className='aboutzz-container' >
      <Top />
      {/* 查询部分 start */}
      <Form hasTap={true} formBase={formBase} hasSearch={true} id={'new'}/>
      {/* 查询部分 end */}
      
      {/* 文字部分 end */}
      {/* 图片部分 start */}
      {/* 版心部分 start */}
      {/* 版心部分 end */}


      {/* 图片部分 end */}
    </div >

  )
}
//默认初始数据配置
Recruit.defaultProps = {

}

export default Recruit